<template>
  <div id="loadpaym" style="position: fixed;left: 0;right: 0;bottom: 0;top:0;background-color: #000;z-index: 1000;opacity: 0.5;display: none;">
    <div class="container">
  <div class="loaderWraper"><img :src="imgPath+'images/palaxi.gif'" width="100" style="z-index: 1001;"></div>
</div></div>

  <main>
    <NavBar :moviedetail="seatdetails" @TimeOut="TimeOut"></NavBar>
    <section class="content-section" data-background="#ffffff"
      style="padding-bottom: 25px; background: rgb(255, 255, 255) none repeat scroll 0% 0%;padding-top: 10px;">
      <CafeDetails :seatblocked="seatdetails" ref="cafed"></CafeDetails>
      <!-- <BookingSummery></BookingSummery> -->
    </section>
    <SiteFooter v-if="!isMobile()"></SiteFooter>
    <mobFooter  v-if="isMobile()"></mobFooter>
  </main>
  <!-- large modal -->
  <div class="modal fade" id="largeModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" style="border: none !important">
        <!--  <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Large Modal</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->
        <div class="modal-body"
          style="  background: url('images/1ci.jpg'); background-size: cover; border-radius: 3px; padding: 0px;">

          <div class="">

            <div class="col-md-12" style="padding: 0px;">




              <div> <img :src="imgPath+'images/popp.png'" alt=""> </div>
              <!-- end membership -->
            </div>
            <div class="form-group" style="margin-bottom: 0px;">

              <div>
                <button class="continue-button" @click="redirectToSuccessPage" data-dismiss="modal">Continue</button>
              </div>



            </div>

            <div> </div>

          </div>


        </div>

      </div>
    </div>
  </div>
</template>
<script>
// import BookingSummery from './BookingSummery.vue';
import CafeDetails from './CafeDetails.vue';
import NavBar from './NavBar.vue';
import SiteFooter from '@/components/UI/SiteFooter.vue';
import mobFooter from '../../Indexmobile/IndexFooter.vue';
export default {
  props: {  
    seatdetails: { default: null }
    },
    data() {
    return {
      imgPath: process.env.BASE_URL,
      orderprocessig:false
    }},
  components: {
    // BookingSummery,
    CafeDetails,
    NavBar,
    mobFooter,
    SiteFooter
  },
  methods: {
    TimeOut() {
this.$refs.cafed.$refs.BookSum.ClearTimer();
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
  }
}

</script>
<style>




legend {
  padding-bottom: 14px;
  text-align: left;
}

</style>